export default function ShippingBanner() {
  return (
    <div className="shipping-banner" aria-label="Free shipping offer">
      <div className="shipping-banner-inner">
        <div className="shipping-offer-tag">Special Offer</div>
        <h2 className="shipping-title">
          Free Shipping <span>All Over India</span>
        </h2>
        <p className="shipping-subtitle">
          No minimum order. No hidden charges. We deliver Paras Organics to every corner of India completely free.
        </p>
        <a href="/vermicompost" className="btn-gold" style={{fontSize:'0.95rem',padding:'0.875rem 2rem'}}>
          Shop Now & Save on Delivery’
        </a>
        {/*<div className="shipping-features">
          <div className="shipping-feat">ðŸšš Pan-India Delivery</div>
          <div className="shipping-feat">ðŸ“¦ Secure Packaging</div>
          <div className="shipping-feat">ðŸ“ Real-time Tracking</div>
          <div className="shipping-feat">âš¡ 3â€“7 Day Delivery</div>
        </div>*/}
      </div>
    </div>
  );
}

